import * as React from 'react';

export const historyRef = React.createRef();

export const replace = (path = '/') => historyRef.current.history.replace(path);
